<template>
  <div class="right">
    <span class="txt" :style="{color:txtColor,fontSize: fontSize+'px'}">{{title}}</span>
    <span class="img" v-if="rightShow"></span>
  </div>
</template>
<script>
    export default {
        components: {},
        props: {
            title: {
                type: String,
                default: ''
            },
            txtColor: {
                type: String,
                default: ''
            },
            rightShow: {
                type: Boolean,
                default: true
            },
            fontSize: {
                type: Number,
                default: 12
            }

        },
        data () {
            return {

            }
        },
        computed: {

        },
        methods: {

        },
        mounted () {}
    }
</script>
<style scoped lang="less">
  .right{
    overflow: hidden;
    position: relative;
    height: 24px;
    max-width: 250px;
    flex: 1;
    .txt{
      font-size: 12px;
      height: 12px;
      font-family: PingFang SC,Arial,sans-serif;
      -webkit-font-smoothing: antialiased;
      font-weight:400;
      color:rgba(102,102,102,1);
      line-height: 12px;
      // background: orange;
      display: table-cell;
      vertical-align: middle;
      text-align: right;
      position: absolute;
      top:6px;
      right: 16px;
    }

    .img{
      width: 12px;
      height: 12px;
      background: url("../../../assets/travelAgency/ic_righticon.png") center center;
      background-size: 100% 100%;
      position: absolute;
      top:6px;
      right: 0;
    }
  }
</style>
